"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var StringManipulater_1 = require("Utils/StringManipulater");
var ProjectRestorer = (function () {
    function ProjectRestorer(projectCounter, projectApiService, projectTemplater, modal) {
        var _this = this;
        this.projectCounter = projectCounter;
        this.projectApiService = projectApiService;
        this.projectTemplater = projectTemplater;
        this.modal = modal;
        this.restore = function (projects) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!lodash_1.default.isArray(projects)) {
                            projects = [projects];
                        }
                        if (projects.length === 0) {
                            return [2, {
                                    success: false,
                                    message: "Not given any projects to restore.",
                                }];
                        }
                        return [4, this.doRestore(projects)];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
        this.confirmRestore = function (project) { return __awaiter(_this, void 0, Promise, function () {
            var entityName;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entityName = this.projectTemplater.isTemplate(project) ? "template" : "Qwilr page";
                        return [4, this.modal.showConfirmModal({
                                title: "Restore ".concat(entityName, "?"),
                                explainer: "This ".concat(entityName, " can't be opened because it's been deleted. Would you like to restore it?"),
                                confirmLabel: "Restore",
                            })];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
    }
    ProjectRestorer.prototype.doRestore = function (projects) {
        return __awaiter(this, void 0, Promise, function () {
            var projectIds, restoreResult, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        projectIds = lodash_1.default.map(projects, function (project) { return project._id; });
                        restoreResult = {
                            success: true,
                            message: "",
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.projectApiService.restoreProjects(projectIds)];
                    case 2:
                        _a.sent();
                        this.projectCounter.add(this.getNumberOfPages(projects));
                        restoreResult.message = this.getRestoreSuccessMessage(projects);
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        restoreResult.success = false;
                        restoreResult.message = this.getRestoreErrorMessage(projects);
                        return [3, 4];
                    case 4: return [2, restoreResult];
                }
            });
        });
    };
    ProjectRestorer.prototype.getNumberOfPages = function (projects) {
        var _this = this;
        return projects.filter(function (project) { return !_this.projectTemplater.isTemplate(project); }).length;
    };
    ProjectRestorer.prototype.getNumberOfTemplates = function (projects) {
        var _this = this;
        return projects.filter(function (project) { return _this.projectTemplater.isTemplate(project); }).length;
    };
    ProjectRestorer.prototype.getRestoreSuccessMessage = function (projects) {
        var numberOfTemplates = this.getNumberOfTemplates(projects);
        var numberOfPages = this.getNumberOfPages(projects);
        if (numberOfTemplates === 0) {
            return "".concat((0, StringManipulater_1.pluralise)(numberOfPages, "page"), " restored.");
        }
        else if (numberOfPages === 0) {
            return "".concat((0, StringManipulater_1.pluralise)(numberOfTemplates, "template"), " restored.");
        }
        else {
            return "".concat((0, StringManipulater_1.pluralise)(numberOfPages, "page"), " and ").concat((0, StringManipulater_1.pluralise)(numberOfTemplates, "template"), " restored.");
        }
    };
    ProjectRestorer.prototype.getRestoreErrorMessage = function (projects) {
        var numberOfTemplates = this.getNumberOfTemplates(projects);
        var numberOfPages = this.getNumberOfPages(projects);
        if (numberOfTemplates === 0) {
            return "".concat((0, StringManipulater_1.pluralise)(numberOfPages, "page"), " can't be restored.");
        }
        else if (numberOfPages === 0) {
            return "".concat((0, StringManipulater_1.pluralise)(numberOfTemplates, "template"), " can't be restored.");
        }
        else {
            return "".concat((0, StringManipulater_1.pluralise)(numberOfPages, "page"), " and ").concat((0, StringManipulater_1.pluralise)(numberOfTemplates, "template"), " can't be restored.");
        }
    };
    return ProjectRestorer;
}());
exports.default = ProjectRestorer;
